import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Button, buttonVariants } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

const tooltipContentClass =
  'bg-white p-2 rounded-md text-xs shadow-xs border border-neutrals-300 text-neutrals-900';

export function KalenderTableActions() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-end gap-2">
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            to={''}
            className={cn(
              buttonVariants({ variant: 'ghost', size: 'icon' }),
              'hover:bg-transparent',
            )}>
            <FontAwesomeIcon icon={faEdit} className="text-primary-blue-600" />
          </Link>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          sideOffset={0}
          className={tooltipContentClass}>
          {t('domain.termine.edit')}
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" className="hover:bg-transparent">
            <FontAwesomeIcon
              icon={faTrashCan}
              className="text-primary-red-400 cursor-pointer"
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          sideOffset={0}
          className={tooltipContentClass}>
          {t('domain.termine.delete')}
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
